import React, {useEffect, useState} from 'react';
import {Spinner} from "reactstrap";
import {
    ADMIN_GET_ROOBET_LEADERBOARD, ADMIN_GET_ROOBET_MONTHS,
} from "../../../queries/queries";
import {useLazyQuery} from "@apollo/client";
import {number_format} from "../../../helpers";
import moment from "moment";

const AdminRoobet = () => {

    const [leaderboardEntries, setLeaderboardEntries] = useState([]);
    const [leaderboardMonths, setLeaderboardMonths] = useState([]);

    const [activeMonth, setActiveMonth] = useState(moment().month() + 1);
    const [activeYear, setActiveYear] = useState(moment().year());

    const [loading, setLoading] = useState(false);

    const [getLeaderboardMonths] = useLazyQuery(ADMIN_GET_ROOBET_MONTHS, {
        fetchPolicy: 'cache-and-network', onCompleted: (e) => {
            setLeaderboardMonths(e.getLeaderboardRoobetMonths);
        }, onError: () => console.log("API Request failed - if this keeps happening, report to developer!")
    });

    const [getLeaderboard] = useLazyQuery(ADMIN_GET_ROOBET_LEADERBOARD, {
        fetchPolicy: 'cache-and-network', onCompleted: (e) => {
            setLeaderboardEntries(e.adminGetLeaderboardRoobet);
        }, onError: () => console.log("API Request failed - if this keeps happening, report to developer!")
    });

    const setActivePeriod = (month, year) => {
        setActiveMonth(month);
        setActiveYear(year);
        getLeaderboard({
            variables: {
                month: month, year: year
            }
        });
    }

    useEffect(() => {
        getLeaderboardMonths();
        getLeaderboard();
    }, []);

    return (

        <div className="card text-bg-dark">
            <div className="card-header d-flex justify-content-between align-items-center">
                Roobet
            </div>

            <div className="card-body p-0">

                <div className="col-md-12 text-center mt-2 mb-2">
                    <div className="btn-group" role="group" aria-label="Basic example">
                        {leaderboardMonths.map(leaderboardMonth => <a
                            onClick={() => setActivePeriod(leaderboardMonth.Month, leaderboardMonth.Year)}
                            className={`btn btn-secondary ${activeYear == leaderboardMonth.Year && activeMonth == leaderboardMonth.Month ? 'active' : ''}`}>{leaderboardMonth.Month}/{leaderboardMonth.Year}</a>)}
                    </div>
                </div>

                <table className="table table-dark table-striped">
                    <thead>
                    <tr>
                        <th>
                            #
                        </th>
                        <th>
                            Player Name
                        </th>
                        <th>
                            Player ID
                        </th>
                        <th>
                            Deposited
                        </th>
                        <th>
                            Wagered
                        </th>
                    </tr>
                    </thead>
                    {loading ? (<Spinner/>) : (<tbody>
                    {leaderboardEntries && leaderboardEntries.length > 0 ? (<>
                        {leaderboardEntries.map((row, index) => {
                            return (<tr key={index}>
                                <th scope="row">
                                    {index + 1}
                                </th>
                                <td>
                                    {row?.PlayerName}
                                </td>
                                <td>
                                    {row?.PlayerId}
                                </td>
                                <td>
                                    -
                                </td>
                                <td>
                                    $ {number_format(row?.WageredAmount)}
                                </td>
                            </tr>);
                        })}
                    </>) : (<></>)}

                    </tbody>)}
                </table>

            </div>
        </div>);

};

export default AdminRoobet;